<template>
  <div>
    <div class="top-spacer"></div>
    <div class="image-wrapper">
      <img src="@/images/newban.png" alt="项目图片" />
    </div>
    <div class="news-page">
      <header>
        <h1>最新资讯</h1>
      </header>
      <section class="news-list">
        <article v-for="article in articles" :key="article.id" class="news-item">
          <h2>{{ article.title }}</h2>
          <time>{{ formatDate(article.date) }}</time>
          <p>{{ article.description }}</p>
          <router-link :to="article.link">阅读更多</router-link>
        </article>
      </section>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter()

const articles = ref([
  {
    id: 1,
    title: '桌面读码设备',
    date: '2025-07-21',
    description: '将设备放置于台面上，通过批量扫码来解放双手...',
    link: '/desktopRedcode'
  },
  {
    id: 2,
    title: '托盘读码设备',
    date: '2025-06-29',
    description: '杭州古峰智能科技有限公司专注为医药批发企业提供药品核验服务...',
    link: '/trayCalibrationMachine'
  },
  {
    id: 3,
    title: '整件读码设备',
    date: '2025-06-29',
    description: '提高准确率，减少人员成本，提升整体出入库效率...',
    link: '/WholePieceReadcode'
  }
])

function formatDate(dateString) {
  const date = new Date(dateString)
  return date.toLocaleDateString('zh-CN', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  })
}
</script>

<style scoped>
.heng {
  background-color: rgb(0, 0, 0);
  width: 50px;
  height: 6px;
  border-radius: 10px;
}

.title {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.top-spacer {
  height: 80px;
  width: 100%;
}

.image-wrapper {
  width: 100%;
  padding: 0;
  margin: 0;
}

.image-wrapper img {
  width: 100%;
  height: auto;
  display: block;
}

.news-page {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}

header {
  text-align: center;
  margin-bottom: 20px;
}

.news-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.news-item {
  background-color: #f9f9f9;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.news-item h2 {
  margin-top: 0;
  font-size: 1.5em;
}

.news-item time {
  display: block;
  color: #777;
  margin-bottom: 10px;
}

.news-item p {
  line-height: 1.5;
}

.news-item a {
  display: inline-block;
  margin-top: 10px;
  color: #007bff;
  text-decoration: none;
}

.news-item a:hover {
  text-decoration: underline;
}
</style>